import { render, staticRenderFns } from "./imageShow.vue?vue&type=template&id=576b8bf6&scoped=true"
import script from "./imageShow.vue?vue&type=script&lang=js"
export * from "./imageShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576b8bf6",
  null
  
)

export default component.exports